import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Modal,
  ModalFooter,
  Button,
  Row,
  Col,
} from '@folio/stripes/components';

class TransitWarningModal extends React.Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    item: PropTypes.object,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  render() {
    const {
      open,
      item,
      onConfirm,
      onCancel,
    } = this.props;

    if (!item) return null;

    const footer = (
      <ModalFooter>
        <Button
          data-test-confirm-transit
          buttonStyle="primary"
          onClick={onConfirm}
        >
          <FormattedMessage id="ui-checkin.transitWarning.confirm" />
        </Button>
        <Button
          data-test-cancel-transit
          onClick={onCancel}
        >
          <FormattedMessage id="ui-checkin.transitWarning.cancel" />
        </Button>
      </ModalFooter>
    );

    return (
      <Modal
        open={open}
        size="small"
        label={<FormattedMessage id="ui-checkin.transitWarning.heading" />}
        footer={footer}
        dismissible
        onClose={onCancel}
        data-test-transit-warning-modal
      >
        <Row>
          <Col xs>
            <p>
              <FormattedMessage
                id="ui-checkin.transitWarning.message"
                values={{
                  title: item.title,
                  barcode: item.barcode,
                  materialType: item.materialType?.name || '',
                  strong: (chunks) => <strong>{chunks}</strong>,
                }}
              />
            </p>
            <p>
              <FormattedMessage id="ui-checkin.transitWarning.consequences" />
            </p>
          </Col>
        </Row>
      </Modal>
    );
  }
}

export default TransitWarningModal;